import React, { useEffect, useState } from "react";

import { Helmet } from "react-helmet";
import * as Animate from "react-reveal";
import { withRouter } from "react-router";
import HeaderNavigation from "../../components/layout/HeaderNavigation";
import { scrollToTop } from "../../utils/scrollToTop";

import Preloader from "../../components/blocks/Preloader";
import { getSingleEventsApi } from "../../store/actions";

const EventDetails = (props) => {
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    scrollToTop();

    const id = props.location.pathname?.slice(8);
    fetchData(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async (eventId) => {
    setLoading(true);
    try {
      const response = await getSingleEventsApi(eventId);
      setDetails(response.data);
      setLoading(false);
    } catch (error) {
      setError("Network Error! Kindly refresh the page.");
      setLoading(false);
    }
  };

  return (
    <div className="relative">
      <Helmet>
        <title>
          {details?.title
            ? `${details.title} | Utiva`
            : "Utiva | Event Details"}
        </title>
        <meta
          name="description"
          content={
            details?.eventShortDescription ||
            "Explore upcoming events by Utiva."
          }
        />
        <meta
          property="og:title"
          content={
            details?.title
              ? `${details.title} | Utiva`
              : "Utiva | Event Details"
          }
        />
        <meta
          property="og:description"
          content={
            details?.eventShortDescription ||
            "Explore upcoming events by Utiva."
          }
        />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
      </Helmet>

      <header className="w-full relative">
        <HeaderNavigation bgdark={false} />
      </header>

      <main className="container mx-auto px-4 ">
        {loading ? (
          <Preloader />
        ) : error ? (
          <p className="text-primary text-lg lg:text-xl">{error}</p>
        ) : (
          <Animate.Fade bottom>
            <section className="w-full max-w-6xl mx-auto">
              <div className=" w-full overflow-hidden">
                <iframe
                  title={details?.title}
                  src={details?.eventLink}
                  style={{ border: 0 }}
                  className="w-full  min-h-screen"
                ></iframe>
              </div>
            </section>
          </Animate.Fade>
        )}
      </main>
    </div>
  );
};

export default withRouter(EventDetails);
